var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{ref:"figureChartRef"},[(_vm.chartConfig.show)?_c('v-chart',{ref:"barChartFornecedor",attrs:{"autoresize":"","options":_vm.chartConfig,"init-options":_vm.initOptions,"theme":_vm.theme}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }